module.exports = require('./helpers/bundle-url').getBundleURL('5GNQ0') + "../homepage-hero.e0a0cd9a.jpg";